import React from 'react'

import { useVisibleDevices } from '@data/device/device'
import Invoice from '../Components/Invoice/Invoice'

const InvoiceReport: React.FC = () => {
  const devices = useVisibleDevices()

  return (
    <div>
      <Invoice devices={devices} />
    </div>
  )
}

export default InvoiceReport
